import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {AthletePropositionBetModuleController} from "../athlete-proposition-bet-module.controller";

export class AthletePropositionBetModuleProps extends BaseModuleProps {
  controller: AthletePropositionBetModuleController;
}
